import script from "./BillingData.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingData.vue?vue&type=script&setup=true&lang=ts"

import "./BillingData.vue?vue&type=style&index=0&id=5761b0c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5761b0c2"]])

export default __exports__